var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/logout 01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 773",
    d: "M6 14L4.70711 12.7071C4.31658 12.3166 4.31658 11.6834 4.70711 11.2929L6 10",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 12L11 12M20 17.2663V7.26633M8 17.2663C8 18.3709 8.89543 19.2663 10 19.2663H14M8 7.26633C8 6.16176 8.89543 5.26633 10 5.26633H14M19.1094 19.8601L17.1094 21.1934C15.7803 22.0795 14 21.1267 14 19.5293V5.00336C14 3.40597 15.7803 2.45319 17.1094 3.33926L19.1094 4.6726C19.6658 5.04353 20 5.66799 20 6.3367V18.196C20 18.8647 19.6658 19.4891 19.1094 19.8601Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.606d017f1d3a443653b7c2d73b52c485.svg";
export { ForwardRef as ReactComponent };